import { fetchAndSetDealOptions } from 'components/views/FounderCreateDeal/_helpers/founderCreateDeal.resolvers';
import useEffectAsync from 'utils/useEffectAsync';
import { handleSubmitDealCreate } from 'components/views/FounderCreateDeal/_helpers/founderCreateDeal.events';
import DealForm from 'components/global/DealForm/DealForm';
import withDismount from 'hocs/withDismount';

const FounderCreateDeal = () => {
  useEffectAsync(fetchAndSetDealOptions);
  return (
    <DealForm onSubmit={handleSubmitDealCreate} />
  );
};

export default withDismount(FounderCreateDeal);
